function openFaqAnswer(answer) {
    answer.style.transition = 'none';
    const border = answer.offsetHeight - answer.clientHeight;
    const height = answer.scrollHeight + border;
    answer.style.transition = '';
    answer.style.maxHeight = height + 'px';
}

function closeFaqAnswer(answer) {
    if (answer.style.maxHeight === 'none') {
        answer.style.maxHeight = answer.offsetHeight + 'px';
        answer.offsetHeight;
    }
    answer.style.maxHeight = 0;
}

document.querySelectorAll('.faq-question').forEach(function (div) {
    const accordionContent = div.nextElementSibling;

    accordionContent.addEventListener('transitionend', function (event) {
        if (event.propertyName === 'max-height' && div.classList.contains('active')) {
            accordionContent.style.maxHeight = 'none';
        }
    });

    div.addEventListener('click', function () {
        div.classList.toggle('active');

        if (div.classList.contains('active')) {
            openFaqAnswer(accordionContent);
            div.querySelector('.faq-toggle').textContent = '−';
        } else {
            closeFaqAnswer(accordionContent);
            div.querySelector('.faq-toggle').textContent = '+';
        }

        // Close all others
        document.querySelectorAll('.faq-question').forEach(function (otherDiv) {
            if (otherDiv !== div && otherDiv.classList.contains('active')) {
                otherDiv.classList.remove('active');
                closeFaqAnswer(otherDiv.nextElementSibling);
                otherDiv.querySelector('.faq-toggle').textContent = '+';
            }
        });
    });
});
